import { twMerge } from 'tailwind-merge';

export function FieldZone({
  title,
  hint,
  children,
  className,
}: {
  title: string;
  hint?: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={twMerge('overflow-hidden rounded-lg bg-gray-50', className)}
    >
      <div className='flex flex-wrap items-baseline justify-between gap-x-3 gap-y-0.5 border-b border-gray-200/60 bg-gray-100/80 px-4 py-2 font-inter'>
        <span className='text-sm font-semibold text-gray-800'>{title}</span>
        {hint && <span className='text-xs text-gray-500'>{hint}</span>}
      </div>
      <div className='space-y-4 p-4'>{children}</div>
    </div>
  );
}
